import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

const AddCardModal = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Legg til Fakturakort</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Ønsker du å legge til dette fakturakortet i lommeboken din?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <Button
            onClick={onClose}
            sx={{
              backgroundColor: 'lightgrey',
              color: 'black',
              '&:hover': {
                backgroundColor: 'grey',
              },
            }}
          >
            Avbryt
          </Button>
          <Button
            onClick={onConfirm}
            sx={{
              backgroundColor: 'green',
              color: 'white',
              '&:hover': {
                backgroundColor: 'darkgreen',
              },
            }}
            autoFocus
          >
            Bekreft
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default AddCardModal;
